const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconsPillow = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M1.985 11.733C2.151 8.498 4.101 5.75 6 3.275c.281-.367.65-.911.958-1.228.014-.014.035-.048.057-.042 1.103 1.421 2.238 2.83 3.17 4.373.976 1.616 1.772 3.718 1.812 5.64l.103-1.242c.414-2.78 2.242-5.325 3.912-7.501.28-.367.65-.911.958-1.228.014-.014.034-.048.057-.042 1.678 2.19 3.567 4.436 4.481 7.083 1.507 4.36-.59 7.794-3.114 11.153-.39.52-.797 1.058-1.208 1.561-.033.04-.14.189-.175.194l-1.4-1.788c-1.576-2.102-3.226-4.542-3.545-7.218-.03-.24-.036-.731-.06-.971-.165 3.796-2.767 7.087-4.965 9.951l-.065.022c-.45-.6-.926-1.183-1.377-1.784-1.755-2.34-3.464-4.918-3.614-7.941v-.534Z",
    style: {
      fill: "none",
      stroke: "#00a000",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconsPillow);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icons_pillow_.431a2ea139092bf6ae97f767693c6344.svg";